import { __spreadArrays } from "tslib";
import Version from '../versioningUtils';
import { removeInlineHeaderRanges } from './removeInlineHeaderRanges';
import { addLinkUnderlineRange, fixAtomicBlockText, addInlineStyleRanges, } from './block-processors';
import { linkify } from './linkify';
// NOTE: the processor order is important
var contentStateProcessingStrategies = [
    { version: '<3.4.7', processors: [linkify] },
];
var blockProcessingStrategies = {
    atomic: [{ processors: [fixAtomicBlockText] }],
    unstyled: [{ processors: [removeInlineHeaderRanges, addInlineStyleRanges] }],
    'ordered-list-item': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'unordered-list-item': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'code-block': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'header-one': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'header-two': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'header-three': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'header-four': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'header-five': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    'header-six': [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
    blockquote: [
        { processors: [removeInlineHeaderRanges, addInlineStyleRanges] },
    ],
};
var entityRangeProcessingStrategies = {
    LINK: [
        {
            version: '<3.4.7',
            processors: [addLinkUnderlineRange],
        },
    ],
};
var isVersionCompatible = function (strategy, contentStateVersion) {
    return strategy.version
        ? Version.evaluate(contentStateVersion, strategy.version)
        : true;
};
var applyStrategies = function (strategies, processed, version) {
    var args = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args[_i - 3] = arguments[_i];
    }
    if (!strategies) {
        return processed;
    }
    var processedUnit = processed;
    strategies
        .filter(function (strategy) { return isVersionCompatible(strategy, version); })
        .forEach(function (strategy) {
        strategy.processors.reduce(function (unit, processor) {
            processedUnit = processor.apply(void 0, __spreadArrays([unit], args));
            return processedUnit;
        }, processed);
    });
    return processedUnit;
};
export var processContentState = function (contentState, config) {
    var _a = contentState.VERSION, contentStateVersion = _a === void 0 ? '0.0.0' : _a;
    // process the whole state
    var processedState = applyStrategies(contentStateProcessingStrategies, contentState, contentStateVersion, config);
    var blocks = processedState.blocks, entityMap = processedState.entityMap;
    return {
        blocks: blocks.map(function (block) {
            var processedBlock = block;
            // process block
            processedBlock = applyStrategies(blockProcessingStrategies[block.type], block, contentStateVersion, entityMap, config);
            // process block entity ranges
            if (processedBlock.entityRanges) {
                processedBlock.entityRanges.forEach(function (range) {
                    var entityType = entityMap["" + range.key].type;
                    processedBlock = applyStrategies(entityRangeProcessingStrategies[entityType], processedBlock, contentStateVersion, range, entityMap, config);
                });
            }
            return processedBlock;
        }),
        entityMap: entityMap,
        VERSION: Version.lessThan(contentStateVersion, Version.currentVersion)
            ? Version.currentVersion
            : contentStateVersion,
    };
};
//# sourceMappingURL=processContentState.js.map